<template>
  <div class="commodityStatistics">
    <headerNotice routerName="商品销售统计"></headerNotice>
    <div v-loading='loading' class="content">
      <div class="header">
        <dateSelector @dateChange="getDataByTime"/>
        <!-- <div class="export">
          <el-button type="text" style="color: #000;">
            统计说明
            <i class="el-icon-question"></i>
          </el-button>
          <el-button type="text" style="color: #000;">
            <i class="el-icon-printer"></i>
            导出
          </el-button>
        </div>-->
      </div>
      <h1 class="title">订货单</h1>
      <sum-list :list="dataSum"/>
          <el-row style="padding-top: 10px;">
            <el-col :span="7" :offset="17">
              <el-radio-group @change='getDataByType' v-model="type" size="medium">
                <el-radio-button :label="0">按规格统计</el-radio-button>
                <el-radio-button :label="1">按商品统计</el-radio-button>
                <el-radio-button :label="2">按分类统计</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <div v-show='type !== 2' id="myChart" style="width: 100%;height:400px; margin-top: 20px;"></div>
          <div v-show='type === 2' id="myChartPie" style="width: 100%;height:400px; margin-top: 20px;"></div>
          <h1 class="title">详细数据</h1>
          <el-table
            :data="goodsData"
            style="width: 100%"
            :default-sort="{prop: 'date', order: 'descending'}"
          >
            <el-table-column align="center" prop="name" label="商品名称"></el-table-column>
            <el-table-column align="center" prop="orderNum" label="订货单数" sortable></el-table-column>
            <el-table-column align="center" prop="orderQuantity" label="订货数量" sortable></el-table-column>
            <el-table-column align="center" prop="orderAmount" label="订货金额(￥)" sortable></el-table-column>
          </el-table>
    </div>
    <!--分页-->
    <div class='pagination-wrapper'>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync='currentPage'
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          center
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import dateSelector from "./dateSelector.vue";
import sumList from "./sumList.vue";
import echarts from "echarts";
export default {
  components: {
    headerNotice,
    sumList,
    dateSelector
  },
  props: {},
  data() {
    return {
      loading:false,
      duration: [],
      pageSize: 10,
      totalCount: 0,
      currentPage: 1,
      type: 0,
      goodsData: [],
      chartData: [],
      dataSum: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 更改时间重新发请求
    getDataByTime(date) {
      this.duration = date
      this.getStatisticsByItem({
        StartTime: date[0],
        EndTime: date[1],
        Type: this.type,
        MaxResultCount: this.pageSize
      })
      this.currentPage = 1
    },
    // 更改类型重新发请求
    getDataByType(type) {
      this.type = type
      this.getStatisticsByItem({
        StartTime: this.duration[0],
        EndTime: this.duration[1],
        Type: type,
        MaxResultCount: this.pageSize
      })
      this.currentPage = 1
    },
     // 订单数据
    getStatisticsByItem(params) {
      let self = this
      self.loading = true
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminStatistics/GetStatisticsByItem",
        params: params,
        success(res) {
          // console.log(res)
          self.goodsData = res.items
          self.totalCount = res.totalCount
          self.chartData = self.initChartData(res)
          self.dataSum = self.getDataSum(res)
          if(self.type < 2) {
            self.initChart();
          } else {
            self.initChartPie();
          }
          self.loading = false
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 总数据
    getDataSum(data) {
      return [
        {title: '订货单数', value: data.totalOrderNum},
        {title: '订货数量', value: data.totalOrderQuantity},
        {title: '订货金额', value: data.totalOrderedAmountNum}
      ]
    },
    // 图表数据处理
    initChartData(data) {
      var temp
      if(this.type < 2) {
        temp = {
          x_name: [],
          yl_amount: [],
          yr_quantity: []
        }
        data.items.forEach((item) => {
          temp.yl_amount.push(item.orderAmount)
          temp.yr_quantity.push(item.orderQuantity)
          temp.x_name.push(item.name)
        })
      } else {
        temp = {
          name: [],
          data: []
        }
        data.items.forEach((item) => {
          temp.data.push({
            value: item.orderAmount,
            name: item.name
          })
          temp.name.push(item.name)
        })
      }
      // console.log(temp);
      return temp
    },
    initChart() {
      var myChart = echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ["订单金额", "订货数量"]
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        // dataZoom: {
        //   show: false,
        //   start: 0,
        //   end: 100
        // },
        xAxis: [
          {
            type: "category",
            // boundaryGap: true,
            // axisLine: { onZero: false },
            data: this.chartData.x_name,
            axisLabel: {
              formatter: (value, index) => {
                if(value.length > 5) {
                  value = value.slice(0, 5) + '...'
                }
                return value
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            // scale: true,
            name: "订单金额/元",
            max: Math.max.apply({}, this.chartData.yl_amount),
            min: 0
            // boundaryGap: [0.2, 0.2]
          },
          {
            type: "value",
            // scale: true,
            name: "数量",
            max: Math.max.apply({}, this.chartData.yr_quantity),
            min: 0
            // boundaryGap: [0.2, 0.2]
          }
        ],
        series: [
          {
            name: "订单金额",
            type: "bar",
            barWidth: "10%",
            animation: false,
            data: this.chartData.yl_amount
          },
          {
            name: "订货数量",
            type: "line",
            yAxisIndex: 1,
            animation: false,
            data: this.chartData.yr_quantity
          }
        ]
      });
    },
    initChartPie() {
      var myChart = echarts.init(document.getElementById("myChartPie"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          right: 120,
          data: this.chartData.name,
        },
        series: [
          {
            name: this.chartData.name,
            type: "pie",
            radius: "80%",
            center: ["50%", "50%"],
            animation: false,
            data: this.chartData.data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            label: {
                normal: {
                  formatter: function (obj) {
                    let name = obj.data.name
                    if(name.length > 5) {
                      name = name.slice(0, 5) + '...'
                    }
                    return name
                  }
                }
              }
          }
        ]
      });
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
          MaxResultCount: val,
          StartTime: this.duration[0],
          EndTime: this.duration[1],
          Type: this.type
      };
      this.getStatisticsByItem(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      let skipCount = (val - 1) * this.pageSize;
      let params = {
          SkipCount: skipCount,
          MaxResultCount: this.pageSize,
          StartTime: this.duration[0],
          EndTime: this.duration[1],
          Type: this.type
      };
      this.getStatisticsByItem(params);
    }
  },
  created() {},
  mounted() {
    // this.initChart();
    // this.initChart2();
  }
};
</script>
<style lang="scss" scoped>
.commodityStatistics {
  .content {
    padding: 0 50px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
  }
  .title {
    padding-left: 20px;
    background: #f3f3f3;
    line-height: 50px;
  }
  .pagination-wrapper {
    text-align: center;
    margin: 30px auto;
  }
}
</style>